// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sawsbuck: PokeData = {
  "id": 586,
  "name": "sawsbuck",
  "height": 19,
  "weight": 925,
  "base_experience": 166,
  "types": [
    PokeType.NORMAL,
    PokeType.GRASS
  ],
  "api_moves": [
    "double-kick",
    "jump-kick",
    "sand-attack",
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "leech-seed",
    "solar-beam",
    "feint-attack",
    "charm",
    "megahorn",
    "nature-power",
    "camouflage",
    "aromatherapy",
    "bullet-seed",
    "energy-ball",
    "zen-headbutt",
    "horn-leech"
  ],
  "moves": [
    "double-kick",
    "jump-kick",
    "tackle",
    "growl",
    "solar-beam",
    "aromatherapy",
    "bullet-seed",
    "energy-ball",
    "zen-headbutt",
    "flower-rush",
    "tri-attack",
    "razor-leaf",
    "purification"
  ],
  "evolution_chain": {
    "id": 297,
    "item": null,
    "species": [
      {
        "name": "deerling",
        "order": 586,
        "types": [
          PokeType.NORMAL,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sawsbuck",
        "order": 587,
        "types": [
          PokeType.NORMAL,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 585,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 141,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
